module.exports = __webpack_public_path__ + "img/product-preview-58.1c186af.png";